/* @pareto-engineering/generator-front 1.0.12 */
import { urljoin as _u } from 'utils'

const basePath = '/blog/'
const slugUrlParam = ':slug([0-9a-z-]{3,80})'
const categoryUrlParam = ':category([0-9a-z-]{3,20})'
const pageUrlParam = ':pageNumber([0-9]{1,3})'

export default {
  HOME                   :basePath,
  LIST                   :basePath,
  LIST_PAGINATED         :_u(basePath, pageUrlParam),
  LIST_CATEGORY          :_u(basePath, 'c', categoryUrlParam),
  LIST_CATEGORY_PAGINATED:_u(basePath, 'c', categoryUrlParam, pageUrlParam),
  SINGLE                 :_u(basePath, slugUrlParam),
  MISSION                :_u(basePath, 'meet-our-associates'),
  POPULAR_PROJECTS       :_u(basePath, 'startup-tasks-to-offload-with-pareto'),
}
